
const state = {
  agency_id: undefined,
  authentication_token: '',
  id: null,
  identity_code: '',
  options: {
    force_xml_agency: false,
  },
  portal_id: undefined,
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'identity_code' },
  { key: 'portal_id' },
]

export default state
